module.exports = __webpack_public_path__ + "static/media/logo_full_color.03d12e00.svg";